import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import {RefObject, useEffect, useRef, useState} from "react";
import {ColGroupDef, ValueFormatterParams} from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import {IReportCompetitorsBenchmark} from "../../../../api/types/report";
import {useAgGridLocale} from "../../../../../../config/globalConfig";
import {DEFAULT_PLAN_COL_DEF} from "../../../../constants";
import {useTranslation} from "react-i18next";
import {Box} from "@mui/material";
import dayjs from "dayjs";

const CompetitorsBenchmarkReport = ({result}: { result: IReportCompetitorsBenchmark[] }) => {
    // Use Translation
    const {t} = useTranslation();

    // REPORT 6
    const [reports, setReports] = useState<IReportCompetitorsBenchmark[]>([]);

    const gridRefArray = useRef<RefObject<AgGridReact>[]>([]);


    // Use AgGrid Locale
    const agGridLocale = useAgGridLocale();

    const defaultColDef = {...DEFAULT_PLAN_COL_DEF, suppressSizeToFit: true};

    const buildColDef = (singleReport: IReportCompetitorsBenchmark): ColGroupDef[] => {
        return [
            {
                headerName: "",
                children: [{
                    headerName: "",
                    field: "category",
                    pinned: "left",
                    width: 150,
                    minWidth: 150
                }]
            },
            {
                headerName: t("pricing:report.competitorsBenchmark.searchDate") + ": " + dayjs(singleReport.searchDate).format("L LT"),
                children: [
                    {
                        headerName: t("pricing:report.competitorsBenchmark.office") + ": " + singleReport.office + " " +
                            t("pricing:report.competitorsBenchmark.site") + ": " + singleReport.site + " " +
                            t("pricing:report.competitorsBenchmark.date") + ": " + dayjs(singleReport.date).format("L") + " " +
                            t("pricing:report.competitorsBenchmark.rentalPeriod") + ": " + singleReport.days,
                        children: [
                            ...singleReport.columns.map((column, index) => {
                                return {
                                    headerName: column,
                                    // field: "values",
                                    minWidth: 120,
                                    valueFormatter: (params: ValueFormatterParams) => {
                                        return params.data.values[index];
                                    }
                                };
                            })
                        ]
                    }
                ]
            }
        ];
    };

    // Use Effect
    useEffect(() => {
        if (result) {
            setReports(result);
        }
    }, [result]);

    return (
        <>
            {reports?.map((report, index) =>
                <Box my={2}>
                    <AgGridCustomTable
                        gridRef={gridRefArray.current[index]}
                        rowData={report.rows}
                        columnDefs={buildColDef(report)}
                        defaultColDef={defaultColDef}
                        rowSelection={"multiple"}
                        pagination={false}
                        localeText={agGridLocale}
                        suppressRowClickSelection={true}
                        domLayout={"autoHeight"}
                        enableRangeSelection={true}
                        enableCellTextSelection={false}
                    />
                </Box>
            )}
        </>
    );
};

export default CompetitorsBenchmarkReport;